// Emotion設定
import React from "react"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"

// 高速化のためのプリロード
export const onClientEntry = () => {
  // Critical resource hints
  if (typeof window !== "undefined") {
    // DNS prefetch for external resources
    const prefetchDomains = [
      "fonts.googleapis.com",
      "fonts.gstatic.com",
      "www.googletagmanager.com",
      "www.google-analytics.com",
      "pagead2.googlesyndication.com",
      "googleads.g.doubleclick.net",
      "tpc.googlesyndication.com",
      "partner.googleadservices.com"
    ];
    
    prefetchDomains.forEach(domain => {
      const link = document.createElement("link");
      link.rel = "dns-prefetch";
      link.href = `//${domain}`;
      document.head.appendChild(link);
    });
  }
};

// Emotion設定の改善
const cache = createCache({
  key: "css",
  prepend: true,
  speedy: true
});

export const wrapRootElement = ({ element }) => {
  return (
    <CacheProvider value={cache}>
      {element}
    </CacheProvider>
  );
};

// エラーハンドリング
export const onRouteUpdate = ({ location }) => {
  // Google Analytics page view tracking
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", "GA_MEASUREMENT_ID", {
      page_path: location.pathname,
    });
  }
};

// パフォーマンス監視
export const onInitialClientRender = () => {
  if (typeof window !== "undefined") {
    // Emotion CSS統計
    const emotionStyleTags = document.querySelectorAll('style[data-emotion]');
    const totalBytes = Array.from(emotionStyleTags).reduce((sum, tag) => sum + tag.innerHTML.length, 0);
    
    // キー別の統計
    const keyBreakdown = {};
    emotionStyleTags.forEach(tag => {
      const key = tag.getAttribute('data-emotion');
      if (key) {
        keyBreakdown[key] = (keyBreakdown[key] || 0) + 1;
      }
    });
    
    // 重複検出
    const duplicateCount = document.querySelectorAll('style[data-emotion-duplicate]').length;
    
    // 開発環境でのみログ出力
    if (process.env.NODE_ENV === 'development') {
      console.log('Emotion CSS統計:', {
        totalStyleTags: emotionStyleTags.length,
        totalBytes,
        keyBreakdown,
        duplicateCount
      });
      
      console.log('Emotion cache設定が完了しました');
    }
  }
}; 